import React from 'react';
import styles from './index.css';
import PropTypes from 'prop-types';
import { getImage } from '../../utils/cutImg';

/**
 * 定义 Content 组件
 * 图文摘要组件
 */
class InsContent extends React.PureComponent {
    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const articleArr = content || [];

        const articlesMap = articleArr.map((eachArticle, index) => {
            let audioCover = null;

            if (eachArticle.type === 'video') {
                // thumbnailsCount > 0
                // ? (audioCover = <img src={eachArticle.thumbnails.image[0].url} className={styles.audioPic} />)
                // : (audioCover = <img />);
                audioCover =
                    eachArticle.thumbnailsCount > 0 ? (
                        <img
                            src={getImage(eachArticle.thumbnails.image[0].url, 300, 179)}
                            className={styles.audioPic}
                        />
                    ) : (
                        <img />
                    );
            }
            let imgInfo = null;

            imgInfo =
                eachArticle.thumbnailsCount > 0 ? (
                    <img src={getImage(eachArticle.thumbnails.image[0].url, 300, 179)} className={styles.bgPic} />
                ) : (
                    <img />
                );

            return (
                <div className={styles.artArea} key={index}>
                    <div className={styles.leftArtPic}>
                        <a href={eachArticle.url} target="_blank" rel="noopener noreferrer">
                            {imgInfo}
                            {audioCover}
                        </a>
                    </div>
                    <div className={styles.rightArtCon}>
                        <a href={eachArticle.url} target="_blank" id="column_art" rel="noopener noreferrer">
                            <h3>{eachArticle.title}</h3>
                            <p>{eachArticle.summary}</p>
                        </a>
                        <div className={styles.artTime}>
                            <p>{eachArticle.newsInsTime}</p>
                            <a href={eachArticle.url} target="_blank" rel="noopener noreferrer">
                                [详情]
                            </a>
                        </div>
                    </div>
                </div>
            );
        });

        return <div className={styles.columnArt}>{articlesMap}</div>;
    }
}

/**
 * 定义组件属性类型
 * */
InsContent.propTypes = { content: PropTypes.array };

/**
 * 定义组件默认属性
 * */
InsContent.defaultProps = {};

export { InsContent };
export default InsContent;
